import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import MyAppointmentsMain from "./MyAppointmentsMain";

const MyAppointments = () => {
  return (
    <>
      <HeaderFour headerClass="it-header-area-two" />
      <MyAppointmentsMain />
      <Footer />
    </>
  );
};

export default MyAppointments;
